<template>
  <div id="app" class="app">
    <header>
      <Header />
    </header>
    <main class="main">
      <div class="main__content">
        <h1 class="main__content-title">BSAC JAPAN eラーニング</h1>
        <router-view></router-view>
      </div>
    </main>
    <footer>
      <Footer />
    </footer>
  </div>
</template>

<script>
import Header from 'vues/common/components/parts/Header';
import Footer from 'vues/common/components/parts/Footer';

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/app-vue.scss';
</style>
